<template>
    <validation-provider ref="provider"
                         v-slot="{ errors, valid }"
                         :name="validatorProps.name || label"
                         :rules="validatorProps.rules || rules"
                         :vid="validatorProps.vid || name"
                         :bails="validatorProps.bails"
                         :debounce="validatorProps.debounce"
                         :immediate="validatorProps.immediate"
                         :mode="validatorProps.mode"
                         :persist="validatorProps.persist"
                         tag="div"
    >
        <field-wrapper :for-id="id"
                       :label="label"
                       :hide-label="$attrs['hide-label']"
                       :spacing="$attrs['spacing']"
                       :error="errors"
        >
            <base-textarea :id="id"
                           v-model="innerValue"
                           v-bind="$attrs"
                           :value.sync="innerValue"
                           :invalid="errors && errors.length > 0"
            />
            <template v-if="$slots.labelTooltip"
                      slot="labelTooltip"
            >
                <slot name="labelTooltip" />
            </template>
        </field-wrapper>
    </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import FieldWrapper from '@/components/form/FieldWrapper';
import BaseTextarea from '../base/BaseTextarea';

export default {
    name: 'FormTextarea',
    components: {
        BaseTextarea,
        FieldWrapper,
        ValidationProvider,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        value: {
            type: null,
            default: undefined,
        },
        rules: {
            type: null,
            default: null,
        },
        validation: {
            type: [Object],
            default: null,
        },
    },
    data() {
        return {
            innerValue: this.value || null,
        };
    },
    computed: {
        validatorProps() {
            return Object.assign({}, this.validation);
        },
    },
    watch: {
        innerValue(val) {
            this.$emit('input', val);
            this.$emit('update:value', val);
        },
        value(val) {
            this.innerValue = val;
        },
    },
    created() {
        this.innerValue = this.value;
    },
};
</script>
